export interface ExportInternalReportParams {
    rangeFrom: any;
    marcaSeleccionada: string;
    monthHeaders: string[];
    tableRows: any[];
    editableData: any;
    summaryRows: any[];
    previousYear: number;
}

export function exportInternalReportExcel(this: any, params: ExportInternalReportParams): Promise<void> {
    const firstMonth = params.monthHeaders[0];
    const lastMonth = params.monthHeaders[params.monthHeaders.length - 1];
    const monthText = firstMonth === lastMonth ? firstMonth : `${firstMonth}-${lastMonth}`;

    return this.$store.dispatch('transaction/exportInternalReport', params, {
        responseType: 'blob',
    }).then((response: any) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = `Reporte-Despachos-${params.marcaSeleccionada}-${params.rangeFrom.year}-${monthText}.xlsx`;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();

        return Promise.resolve();
    }).catch((error: any) => {

        return Promise.reject(error);
    });
}

export interface ExportVinParams {
    title_download: string;
    title: string;
    year: number;
    monthName: string;
    columnsCount: number;
    headers: string[];
    rows: any[];
}

export function exportVinListExcel(this: any, params: ExportVinParams): Promise<void> {
    return this.$store.dispatch('transaction/downloadDynamicReport', params, {
        responseType: 'blob',
    }).then((response: any) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${params.title_download || 'Reporte'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.remove();
    }).catch((error: any) => {
        return Promise.reject(error);
    });
}
